import {
  ApplicationContextualHelp,
  ApplicationSectionHeader,
} from "../../../components/application";
import DashboardProjectsSection from "../../../layouts/components/dashboard/DashboardProjectsSection";
import JoinProjectWithCode from "../../../layouts/components/dashboard/JoinProjectWithCode";

export default function ProjectParticipationSection({
  title,
  description,
  headingLevel = 2,
}) {
  const content = (
    <>
      <DashboardProjectsSection
        headingLevel={Math.min(headingLevel + 1, 6)}
      />
      <JoinProjectWithCode
        headingLevel={Math.min(headingLevel + 1, 6)}
      />
    </>
  );

  if (!title) {
    return content;
  }

  return (
    <section aria-labelledby="project-participation-section-title">
      <ApplicationSectionHeader
        description={description}
        headingLevel={headingLevel}
        title={(
          <span className="av-app-section-header__title-row">
            <span>{title}</span>
            <ApplicationContextualHelp
              label="About Projects"
              title="About Projects"
              learnMoreLabel="Learn more about Projects"
              learnMoreTo="/app/guide#catalog-resource-guide-projects"
            >
              <p>
                Projects are tailored All-Voiced spaces configured for a
                specific course, research study, perceptual data initiative,
                or institutional workflow. If a Project has been made
                available to you, you can access it here or join with a code
                provided by the organizer.
              </p>
            </ApplicationContextualHelp>
          </span>
        )}
        titleId="project-participation-section-title"
      />

      {content}
    </section>
  );
}
